import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../../components/base/Navbar";
import Footer from "../../components/base/Footer";
import Contact from "../../components/Contact";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/fontawesome-free-solid";

const months = ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];

export default function NewsletterYearList() {
    const { year } = useParams();
    const [visible, setVisible] = useState({}); // { [month]: boolean }
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const token = localStorage.getItem("token");
    const isAdmin = !!token;
    const axiosAuth = {
        withCredentials: false, // Cookie-Session? -> true und Header weg
        headers: token ? { Authorization: `Bearer ${token}` } : {}
    };

    const load = async () => {
        setLoading(true);
        try {
            if (isAdmin) {
                const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/newsletter/${year}`, axiosAuth);
                const v = {};
                (res.data || []).forEach(row => { v[row.month] = !!row.visible; });
                setVisible(v);
            } else {
                const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/${year}`, {
                    withCredentials: false,
                    headers: {},
                });
                const v = {};
                (res.data || []).forEach(x => { v[x.month] = true; });
                setVisible(v);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); /* eslint-disable-next-line */ }, [year, isAdmin]);

    const toggleMonth = async (m) => {
        if (!isAdmin) return;
        const current = !!visible[m];
        setVisible(prev => ({ ...prev, [m]: !current })); // optimistic
        try {
            await axios.patch(
                `${process.env.REACT_APP_BACKEND_URL}/api/admin/newsletter/${year}/${m}/visibility`,
                { visible: !current },
                axiosAuth
            );
        } catch {
            setVisible(prev => ({ ...prev, [m]: current })); // rollback
            alert("Konnte Sichtbarkeit nicht speichern.");
        }
    };

    return (
        <div className="bg-gray-200 pt-24 bg-center">
            <Navbar />

            <div className="w-full m-12"></div>

            <div className="my-4 text-center">
                <h1 className="md:text-6xl text-5xl text-blue font-bold drop-shadow-md
          bg-gradient-to-r from-blue-500 to-blue-800 inline-block uppercase text-transparent bg-clip-text">
                    Newsletter
                </h1>
                <p className="text-neutral-400 text-center font-bold">Erhalte immer die neusten News!</p>
                {isAdmin && <p className="mt-2 text-xs text-neutral-500">Admin-Modus: Monate inkl. Sichtbarkeit & Toggle</p>}
            </div>

            <div className="w-full m-12"></div>
            <div className="bg-gray-100/50 bg-border h-[5px]"></div>

            <div className="flex flex-col md:flex-row md:items-center md:justify-between px-4">
                <div className="my-4 text-center md:text-left">
                    <h1 className="text-4xl md:text-6xl inline-block uppercase font-bold drop-shadow-md
            bg-gradient-to-r from-gray-800 to-gray-500 text-transparent bg-clip-text">
                        Übersicht
                    </h1>
                    <h1 className="text-4xl md:text-6xl md:ml-4 ml-2 inline-block font-bold drop-shadow-md
            bg-gradient-to-r from-green-500 to-green-800 text-transparent bg-clip-text">
                        {year}
                    </h1>
                </div>

                <Link
                    to="/newsletter"
                    className="flex justify-center items-center mt-4 md:mt-0
            bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold
            py-2 px-4 rounded w-full md:w-auto"
                >
                    <FontAwesomeIcon icon={faHome} className="w-4 h-4 mr-2" />
                    <span>Zurück</span>
                </Link>
            </div>

            <div className="w-full m-12"></div>

            <div className="flex items-center justify-center self-center space-y-8">
                <div className="container grid grid-cols-3 gap-4 max-[800px]:grid-cols-1">

                    {/* Lade-Animation */}
                    {loading ? (
                        Array.from({ length: 6 }).map((_, idx) => (
                            <div key={idx}
                                 className="mx-auto w-full max-w-sm rounded-3xl border border-gray-200 p-6 drop-shadow-lg animate-pulse bg-gray-200">
                                <div className="flex space-x-4">
                                    <div className="size-12 rounded-full bg-gray-300"></div>
                                    <div className="flex-1 space-y-4 py-1">
                                        <div className="h-4 rounded bg-gray-300 w-3/4"></div>
                                        <div className="space-y-3">
                                            <div className="grid grid-cols-3 gap-4">
                                                <div className="col-span-2 h-3 rounded bg-gray-300"></div>
                                                <div className="col-span-1 h-3 rounded bg-gray-300"></div>
                                            </div>
                                            <div className="h-3 rounded bg-gray-300"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        months.map((monthName, index) => {
                            const m = index + 1;
                            const isVisible = !!visible[m];

                            // Public: nur sichtbare Monate zeigen; Admin: alle 12 anzeigen
                            if (!isAdmin && !isVisible) return null;

                            return (
                                <div key={index} className="flex justify-center">
                                    <div
                                        className={`relative flex flex-col sm:flex-row items-center justify-center
                                border-2 rounded-3xl py-8 px-12 sm:py-16 sm:px-28 drop-shadow-lg group
                                w-full max-w-sm
                                ${isVisible ? "bg-white border-gray-200" : "bg-gray-100 border-gray-300 opacity-90"}`}
                                    >
                                        <button
                                            onClick={() => navigate(`/newsletter/${year}/${m}`)}
                                            className="flex flex-col sm:flex-row items-center justify-center"
                                        >
                                            <p className="text-xl sm:text-2xl mr-0 sm:mr-4 uppercase font-bold drop-shadow-md
                                    bg-gradient-to-r from-blue-500 to-blue-800 text-transparent bg-clip-text">
                                                {monthName}
                                            </p>
                                            <h2 className="text-2xl sm:text-4xl font-bold bg-gradient-to-r
                                      from-gray-800 to-gray-500 text-transparent bg-clip-text">
                                                {year}
                                            </h2>
                                        </button>

                                        <div className="absolute bottom-4 right-4 text-white z-20 p-2
                                    bg-blue-400 backdrop-blur-xl rounded-full flex
                                    drop-shadow-lg items-center justify-center
                                    group-hover:-translate-x-1 group-hover:-translate-y-1
                                    transition-all duration-300">
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                 width="24" height="24" viewBox="0 0 24 24"
                                                 fill="none" stroke="currentColor" strokeWidth="2"
                                                 strokeLinecap="round" strokeLinejoin="round"
                                                 className="h-6 w-6">
                                                <path d="M7 7h10v10"></path>
                                                <path d="M7 17 17 7"></path>
                                            </svg>
                                        </div>

                                        {isAdmin && (
                                            <div className="absolute top-4 right-4">
                                                <button
                                                    onClick={() => toggleMonth(m)}
                                                    className={`px-3 py-1 rounded text-sm font-semibold transition
                                      ${isVisible ? "bg-green-600 text-white" : "bg-gray-400 text-white"} hover:ring-2`}
                                                    title={isVisible ? "Öffentlich sichtbar – klicken zum Ausblenden" : "Ausgeblendet – klicken zum Anzeigen"}
                                                >
                                                    {isVisible ? "Öffentlich" : "Ausgeblendet"}
                                                </button>
                                            </div>
                                        )}

                                        {isAdmin && (
                                            <span className={`absolute bottom-4 left-4 text-xs px-2 py-1 rounded
                                        ${isVisible ? "bg-green-100 text-green-700" : "bg-gray-200 text-gray-700"}`}>
                        {isVisible ? "Sichtbar" : "Versteckt"}
                      </span>
                                        )}
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>

            <div className="w-full m-12"></div>
            <Contact />
            <div className="w-full m-12"></div>
            <Footer />
        </div>
    );
}


